import Inputmask from "inputmask";

const PhoneNumberDirective = angular
    .module("PhoneNumberDirective", [])
    .directive("phoneNumber", phoneNumber);

/**
 * @see http://stackoverflow.com/a/19228302/4454238
 */
function phoneNumber() {
    return {
        require: "ngModel",
        restrict: "A",
        priority: 1000,
        link: function (scope, element, attr, ctrl) {
            const DOM_element = element[0];
            Inputmask({ mask: "(***) ***-****", autoUnmask: true, showMaskOnHover: false }).mask(
                DOM_element
            );
            ["keyup", "paste", "focus", "blur"].forEach((e) => {
                DOM_element.addEventListener(e, function () {
                    const val = DOM_element.value;
                    ctrl.$setViewValue(val);
                    ctrl.$render();
                });
            });

            const pattern = /^\d{10}$/;

            const newValue = null;

            ctrl.$validators.validDigits = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }
                if (pattern.test(viewValue)) {
                    // it is valid
                    return true;
                }
                // it is invalid
                return false;
            };
        }
    };
}

export default PhoneNumberDirective;
